export default "__VITE_ASSET__AiDJgQ5u__"